import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  return <section id="testimonials" className="py-24 lg:py-32 px-6 lg:px-12 max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-175">
      {/* Left Images (Before/After) */}
      <motion.div initial={{
      opacity: 0,
      x: -30
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="flex-1 w-full" data-id="element-176">
        <div className="grid grid-cols-2 gap-4" data-id="element-177">
          <div className="relative aspect-[3/4] overflow-hidden" data-id="element-178">
            <img src="https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?auto=format&fit=crop&q=80&w=800" alt="Before Treatment" className="w-full h-full object-cover grayscale-[30%]" data-id="element-179" />
          </div>
          <div className="relative aspect-[3/4] overflow-hidden" data-id="element-180">
            <img src="https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?auto=format&fit=crop&q=80&w=800" alt="After Treatment" className="w-full h-full object-cover" data-id="element-181" />
          </div>
        </div>
        <div className="flex justify-between mt-4 text-[10px] uppercase tracking-widest font-sans text-taupe-dark px-2" data-id="element-182">
          <span data-id="element-183">Before</span>
          <span data-id="element-184">After</span>
        </div>
      </motion.div>

      {/* Right Content */}
      <motion.div initial={{
      opacity: 0,
      x: 30
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className="flex-1 w-full flex flex-col items-center text-center" data-id="element-185">
        <h2 className="font-serif text-4xl lg:text-5xl font-light text-black mb-6" data-id="element-186">
          Testimonials
        </h2>
        <div className="flex items-center justify-center gap-2 mb-12" data-id="element-187">
          <span className="w-12 h-[1px] bg-taupe/50" data-id="element-188"></span>
          <div className="w-1.5 h-1.5 rotate-45 bg-taupe-dark" data-id="element-189"></div>
          <span className="w-12 h-[1px] bg-taupe/50" data-id="element-190"></span>
        </div>

        <div className="bg-white p-10 lg:p-16 shadow-sm border border-taupe/10 relative w-full" data-id="element-191">
          <Quote size={48} className="text-taupe/20 absolute top-8 left-8 rotate-180" data-id="element-192" />

          <p className="font-serif italic text-xl lg:text-2xl leading-relaxed text-black/80 mb-10 relative z-10 px-4 pt-6" data-id="element-193">
            "My areolas were never the same after my breast reconstruction
            surgery. It was something that really bothered me, but I didn't
            think there was much I could do about it. Then I came across Jeff
            and his team. I saw their work online, and it was clear they knew
            their stuff. When I met them in person, they walked me through
            everything step by step. The results were incredible. The tattoos
            matched my skin tone so well, and now everything looks so much more
            natural. I finally feel like myself again."
          </p>

          <div className="flex flex-col items-center gap-2" data-id="element-194">
            <span className="w-6 h-[1px] bg-taupe mb-2" data-id="element-195"></span>
            <span className="font-serif text-2xl text-black" data-id="element-196">Michelle R.</span>
            <span className="text-[10px] uppercase tracking-widest font-sans text-taupe-dark" data-id="element-197">
              Customer
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}